// extracted by mini-css-extract-plugin
export default {"form-main":"getintouchform_form-main__X25Wz","form-control":"getintouchform_form-control__s+ov-","primary":"getintouchform_primary__bW6bz"};